import { AgentBroker } from '../domain/agentBroker.model'
import apiClient from '../infraestructure/apiClient'

export default {
  getAgentBroker: function(id?: string) {
    return apiClient.get<AgentBrokerResponseDTO>(`/agentBroker/${id}`)
  },

  putAgent: function(agent: AgentBroker) {
    return apiClient.put<AgentBrokerResponseDTO>(
      `/agentBroker/${agent.userName}`,
      agent,
    )
  },
}

interface AgentBrokerResponseDTO {
  data: AgentBroker
  error?: {
    description: string
    errorCode: number
  }
  status: string
}
